import { DirectiveOptions } from 'vue'
import { UserModule } from '@/store/modules/user'
import { RoleData } from '@/utils/config'

export const role: DirectiveOptions = {
  inserted(el, binding) {
    const { value } = binding
    const role = RoleData[UserModule.userInfo.role]
    if (value && value instanceof Array && value.length > 0) {
      const permissionRoles = value
      const hasPermission = permissionRoles.includes(role)
      if (!hasPermission) {
        el.style.display = 'none'
      }
    } else {
      throw new Error('need roles! Like v-permission="[\'admin\',\'editor\']"')
    }
  }
}
